import { IdentificationIcon } from "@heroicons/react/24/solid";
import { PERMISSIONS, ROUTE_PATHS } from "../../../PermissionsConstants";
import { BusinessLicensesPermitsReport } from "./BusinessLicensesPermitsReport";
import { BusinessLicensesPermitsReportWestBU } from "./BusinessLicensesPermitsReportWestBU";
export const BLPSideBar = [
  {
    title: "Business License Listing - ALL Confie",
    to: ROUTE_PATHS.Business_License_Listing_ALL_Confie,
    component: BusinessLicensesPermitsReport,
    permission:
      PERMISSIONS.permission_report_businesslicensepermit_businesslicensespermitreportsall_view,
  },
  {
    title: "Business License Listing - West BU",
    to: ROUTE_PATHS.Business_License_Listing_West_BU,
    component: BusinessLicensesPermitsReportWestBU,
    permission:
      PERMISSIONS.permission_report_businesslicensepermit_businesslicensespermitreportswestbu_view,
  },
];
